
import {
  CATEGORY_TICKET_DATA,
  CATEGORY_SUBCATEGORY_DATA,
  CATEGORY_SUBCATEGORY_CONFIG_DATA,
  CATEGORY_GET_DATA,
  CATEGORY_FORM_ADD_DATA,
  CATEGORY_UPDATE_DATA,
  CATEGORY_DELETE_DATA,
  CATEGORY_GET_ALL_DATA,
  CATEGORY_UPDATE_ALL_DATA,
  CATEGORY_DELETE_ALL_DATA,

} from "./Constants";

const initialState = {
  loading: false,
  error: null,
  categorylist: {},
  categories: {},
  category: {},
  categoryform: {}, 
  allcategories: [],
  categoriesSuccess: false, 
  updateAllError: false,
  updateAllSuccess: false,
  deleteAllError: false,
  deleteAllSuccess: false,
};

const Reducer = (state = initialState, action) => {
  switch (action.type) {

    //load all list
    case CATEGORY_TICKET_DATA.CATEGORY_TICKET_DATA_LOAD:
      return {
        ...state,
        loading: true,
        categorylist: {},
        error: null,
      };
    case CATEGORY_TICKET_DATA.CATEGORY_TICKET_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        categorylist: { data: action.categorylist },
      };
    case CATEGORY_TICKET_DATA.CATEGORY_TICKET_DATA_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    //load all 
    case CATEGORY_SUBCATEGORY_DATA.CATEGORY_SUBCATEGORY_DATA_LOAD:
      return {
        ...state,
        loading: true,
        categories: {},
        error: null,
      };
    case CATEGORY_SUBCATEGORY_DATA.CATEGORY_SUBCATEGORY_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        categories: { data: action.categories },
      };
    case CATEGORY_SUBCATEGORY_DATA.CATEGORY_SUBCATEGORY_DATA_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    //load all 
    case CATEGORY_SUBCATEGORY_CONFIG_DATA.CATEGORY_SUBCATEGORY_CONFIG_DATA_LOAD:
      return {
        ...state,
        loading: true,
        categoryconfig: {},
        error: null,
      };
    case CATEGORY_SUBCATEGORY_CONFIG_DATA.CATEGORY_SUBCATEGORY_CONFIG_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        categoryconfig: { data: action.categoryconfig },
      };
    case CATEGORY_SUBCATEGORY_CONFIG_DATA.CATEGORY_SUBCATEGORY_CONFIG_DATA_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
      };  

    //Get by id
    case CATEGORY_GET_DATA.CATEGORY_GET_DATA_LOAD:
      return {
        ...state,
        loading: true,
        category: {},
        error: null,
      };
    case CATEGORY_GET_DATA.CATEGORY_GET_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        category: action.category,
        error: null,
      };
    case CATEGORY_GET_DATA.CATEGORY_GET_DATA_FAIL:
      return {
        ...state,
        loading: false,
        category: {},
        error: action.error,
      };
    // Add 
    case CATEGORY_FORM_ADD_DATA.CATEGORY_FORM_ADD_DATA_LOAD:
      return {
        ...state,
        loading: true,
        categoryform: {},
        error: null,
      };
    case CATEGORY_FORM_ADD_DATA.CATEGORY_FORM_ADD_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        categoryform: action.categoryform,
        error: null,
      };
    case CATEGORY_FORM_ADD_DATA.CATEGORY_FORM_ADD_DATA_FAIL:
      return {
        ...state,
        loading: false,
        categoryform: {},
        error: action.error,
      };
    // Update 
    case CATEGORY_UPDATE_DATA.CATEGORY_UPDATE_DATA_LOAD:
      return {
        ...state,
        loading: true,
        error: null
      }
    case CATEGORY_UPDATE_DATA.CATEGORY_UPDATE_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        category: action.category,
        error: false
      }
    case CATEGORY_UPDATE_DATA.CATEGORY_UPDATE_DATA_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error
      }

    case CATEGORY_UPDATE_DATA.CATEGORY_UPDATE_DATA_RESET:
      return {
        ...state,
        loading: false,
        category: {},
        categoryform: {},
        categories: [],
        error: null
      };

    // Delete 
    case CATEGORY_DELETE_DATA.CATEGORY_DELETE_LOAD:
      return {
        ...state,
        loading: true,
        category: {},
        error: null,
      };
    case CATEGORY_DELETE_DATA.CATEGORY_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        category: action.category,
        error: null,
      };
    case CATEGORY_DELETE_DATA.CATEGORY_DELETE_FAIL:
      return {
        ...state,
        loading: false,
        category: {},
        error: action.error,
      };

    //load all list
    case CATEGORY_GET_ALL_DATA.CATEGORY_GET_ALL_DATA_LOAD:
      return {
        ...state,
        loading: true,
        allcategories: {},
        categoriesSuccess:false,
        error: null,
      };
    case CATEGORY_GET_ALL_DATA.CATEGORY_GET_ALL_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        allcategories: action.allcategories ,
        categoriesSuccess: true,
      };
    case CATEGORY_GET_ALL_DATA.CATEGORY_GET_ALL_DATA_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    // Update all
    case CATEGORY_UPDATE_ALL_DATA.CATEGORY_UPDATE_ALL_DATA_LOAD:
      return { ...state, loading: true, error: null, updateAllSuccess: false, updateAllError: null };
    case CATEGORY_UPDATE_ALL_DATA.CATEGORY_UPDATE_ALL_DATA_SUCCESS:
      return { ...state, loading: false, updateAllSuccess: true, updateAllError: null };
    case CATEGORY_UPDATE_ALL_DATA.CATEGORY_UPDATE_ALL_DATA_FAIL:
      return { ...state, loading: false, updateAllSuccess: false, updateAllError: action.error };

    // Delete all
    case CATEGORY_DELETE_ALL_DATA.CATEGORY_DELETE_ALL_LOAD:
      return { ...state, loading: true, error: null, deleteAllSuccess: false, deleteAllError: null };
    case CATEGORY_DELETE_ALL_DATA.CATEGORY_DELETE_ALL_SUCCESS:
      return { ...state, loading: false, deleteAllSuccess: true, deleteAllError: null };
    case CATEGORY_DELETE_ALL_DATA.CATEGORY_DELETE_ALL_FAIL:
      return { ...state, loading: false, deleteAllSuccess: false, deleteAllError: action.error };

    default:
      return {
        ...state,
      };
  }
};
export default Reducer;
